import { isPathSegment } from '../../../../http/server/path.ts';
import { PathElement } from './path-element.ts';
import { MatchingContext } from '../path-pattern.ts';

/*internal*/ export class WildcardPathElement extends PathElement {
    constructor(pos: number, separator: number) {
        super(pos, separator);
    }

    matches(pathIndex: number, matchingContext: MatchingContext): boolean {
        let segmentData: string = undefined!;
        if (pathIndex < matchingContext.pathLength) {
            const element = matchingContext.pathElements[pathIndex];
            if (!isPathSegment(element)) {
                // should not match a separator
                return false;
            }
            segmentData = element.valueToMatch;
            pathIndex++;
        }

        if (this.noMorePattern()) {
            if (matchingContext.determinedRemainingPath) {
                matchingContext.remainingPathIndex = pathIndex;
                return true;
            }
            else {
                // and the path data has run out too
                return (pathIndex === matchingContext.pathLength);
            }
        }
        else {
            // within a path (e.g. /aa/*/bb) there must be at least one character to match the wildcard
            if (segmentData === undefined || segmentData.length === 0) {
                return false;
            }
            return (this.next !== undefined && this.next.matches(pathIndex, matchingContext));
        }
    }

    get normalizedLength(): number {
        return 1;
    }

    get chars() {
        return new Uint16Array(['*'.charCodeAt(0)]);
    }

    get wildcardCount(): number {
        return 1;
    }

    get score(): number {
        return PathElement.WILDCARD_WEIGHT;
    }

    toString() {
        return `Wildcard(*)`;
    }
}
